import React from 'react';
import { render } from '@testing-library/react';
import { Form } from './Form';
import { Input } from '../Input';

describe('Form', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Form data-auto-sel="automation-selector">
				<Form.Field label="Label" width="3">
					<Input placeholder="First" className="input1" />
					<Input placeholder="Last" className="input2" />
				</Form.Field>
			</Form>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
